import axios from '../../axios'

/**
 * 导出
 * @param schoolId 驾校id
 * @param name 期别名称
 * @param stageCode 期别编号
 * @param state 状态
 */
export const exportExcel = data => {
  return axios({
    url: '/period/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 保存
export const save = (data) => {
  return axios({
    url: '/period/save',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/period/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/period/list',
    method: 'post',
    data
  })
}
// 分页查询
export const detailView = (data) => {
  return axios({
    url: '/period/detail',
    method: 'post',
    data
  })
}
// 条件查询
export const listByCondition = (data) => {
  return axios({
    url: '/period/listByCondition',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/period/period.js